<template>
  <FormationDetailLayout
    lesson="Formation Mobilité"
    back-item="carte-pro-vtc-taxi"
    :hero-image="heroImage"
    hero-alt="formation mobilite taxi"
    hero-eyebrow="Extension carte taxi"
    hero-title="MOBILITÉ<br />92 / 75"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>formation Mobilité taxi</h2>

        <div class="formation-flow">
          <h3>Ajouter un departement a sa carte professionnelle taxi</h3>
          <p>
            Notre <strong>formation mobilité</strong> vous ouvre de nouvelles
            perspectives en vous permettant d'<strong
              >étendre votre activité de taxi à différents départements</strong
            >. Avec cette <strong>formation</strong> spécialisée, vous pourrez
            obtenir l'extension de votre
            <strong>carte professionnelle taxi</strong> dans des départements
            spécifiques, vous offrant ainsi la possibilité de desservir une
            clientèle plus large et de développer votre entreprise.
          </p>

          <h3>Mobilité taxi 92</h3>
          <p>
            Le <strong>département 92</strong> est une zone très dynamique avec
            une forte demande de<strong>services de taxi</strong>. En suivant
            notre <strong>formation mobilité pour le 92</strong>, vous serez en
            mesure d'opérer dans de nombreuse villes des
            <strong>Hauts-de-Seine</strong>. Vous apprendrez les spécificités de
            la réglementation locale, les zones géographiques clés et les
            principales attentes des clients de ce département.
          </p>

          <h3>Mobilité taxi 75</h3>
          <p>
            En ce qui concerne le <strong>département 75</strong>, il représente
            le cœur de la capitale, <strong>Paris</strong>, et constitue un
            marché très attractif pour les <strong>chauffeurs de taxi</strong>.
            Grâce à notre <strong>formation mobilité pour le 75</strong>, vous
            pourrez étendre votre activité à Paris et desservir les
            arrondissements célèbres tels que le Marais, Montmartre, les
            Champs-Élysées et bien d'autres. Vous acquerrez les connaissances
            nécessaires sur la réglementation spécifique à
            <strong>Paris</strong>, les itinéraires courants et les
            particularités du transport de personnes dans cette métropole
            animée.
          </p>

          <p>
            Que vous choisissiez d'étendre votre activité dans le
            <strong>92</strong> ou le <strong>75</strong>, notre
            <strong>formation mobilité</strong> vous donnera les compétences
            nécessaires pour réussir dans ces départements. Ne manquez pas cette
            occasion de diversifier votre clientèle et d'élargir vos horizons
            professionnels en
            <strong>ajoutant ces nouvelles zones à votre carte taxi</strong>.
          </p>
        </div>
      </article>
    </template>
  </FormationDetailLayout>
</template>

<script>
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/formation-mobilite.webp");
const heroStats = [
  { label: "Prix", value: "449€" },
  { label: "Durée", value: "14h / horaires à convenir" },
];

export default {
  name: "MobiliteDepartement",
  components: { FormationDetailLayout },
  setup() {
    useMeta({
      title: "Formations Mobilité taxi",
      description: [
        {
          content:
            "Formation Mobilité Taxi (92, 75) : Développez votre mobilité professionnelle avec notre formation spécialisée dans les départements des Hauts-de-Seine, Paris. Obtenez les compétences nécessaires pour exercer l'activité de taxi dans ces zones dynamiques. Rejoignez-nous pour une formation pratique et complète",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-mobilite-taxi-92",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
